export default __webpack_public_path__ + "static/media/img15.f4eee6a8.JPG";